<template>

    <div class="">

        <div class="myStickyBar">

            <!-- <div class="barTitleDiv">

                <label class="barTitleText">{{$t('menu.sessions')}}</label>
            </div> -->


            <div class="w-full border border-gray-200" :key="slot.length">

                <sessions-panel :panelObject="panelObject" :allSlots="slot" ref="sessionsPanel"
                :user="user" :fixedDayDate="fixedDayDate" :openMapModal="openMapModal" :refreshMap="refreshMap"
                 :setDate="setDateFromPanel" :slotsCategoriesOptions="slotsCategoriesOptions"/>
            </div>

            <div class="myDateBar">

                <my-date-bar :myDates="myDates" :setDate="setDateFromBar" ref="sessionsBar" :useWithPanel="true"/>
            </div>

            <div v-if="!isFromBusinessBrowse">

                <my-tabs :itemIsSelected="tabIsSelected"/>
            </div>

        </div>

        <div class="mySessionsMainDiv" v-if="tokenId != '' && !$apollo.loading && !loading">

            <div v-if="userId != 0" class="overflow-y-scroll w-full h-full allText">

                <transition  name="right-in">

                    <div v-if="showMap" class="myMapDiv mb-40">
                    <!-- <div v-if="showMap" class="myMapDiv" :key="panelObject.dayDate"> -->

                        <sessions-map-modal :showModal="showMap" :modalSlots="panelObject.categorizedSlots" :highlightedLocation="highlightedLcoation"
                        :userId="userId" :myReload="myReload" :isCard="true" :displayModal="displayModal" :showDescription="showDescription" 
                        :book="book" :dayDate="panelObject.dayDate" :disableButton="disableButton" :refreshedMap="refreshedMap"
                        :changeShowModal="changeShowMapModal" :showOnlyTheOneSlot="showOnlyTheOneSLot" :oneSlot="selectedOneSlot"/>
                    </div>
                </transition>


                <transition  name="bottom-up">

                    <div v-if="displayClassPage && userId != 0"
                    class="modalDiv myFullCenter h-full">
                        

                        <div class="subModalDiv" v-click-outside="closeClassPage" :key="panelObject.dayDate">

                            <session-page :userId="userId" :myClass="myClass" :closeClassPage="closeClassPage"
                            :lastDayDate="panelObject.dayDate" :reload="myReload" :isIos="isIos" :callSetSessionIsBooked="setASessionIsBooked"
                             :isFromBusinessBrowse="isFromBusinessBrowse" :isFromInstructorBrowse="isFromInstructorBrowse"/>
                        </div>
                    </div>
                </transition>

                <div v-show="!showMap">

                    <div v-if="panelObject.categorizedSlots.length > 0"
                    class="myColCenter lg:p-5 myRounded h-full">
                        
                        <div class="mySessionsDivider" >
                            
                            <div class="myCardDiv" ref="slotRef" :key="oneSlot.id" 
                             v-for="(oneSlot, index) in panelObject.categorizedSlots">

                                <session-card ref="slotInfoChild" :tokenId="tokenId" :key="panelObject.dayDate" :isOnline="false"
                                :email="email" :userId="userId" :myReload="myReload" :isCard="false"
                                :mySlot="oneSlot" :book="book" :index="index" :dayDate="panelObject.dayDate"
                                :disablePage="disablePage" :showDescription="showDescription" :showClassPage="showClassPage"
                                :disableButton="disableButton" :openOneSlotMapModal="openOneSlotMapModal"/>
                            </div>
                        </div>
                    </div>
                    <div v-else class="h-40">
                        
                        <div class="myFullCenter mt-40">
                            
                            <p class="mt-2 lg:mt-5 p-5 bg-blue-300 rounded-full border-blue-800 border-4">
                                <strong>{{$t('sessions.noSessionsAvailable')}}</strong></p>
                        </div>
                    </div>
                </div>                
            </div>

            <div v-else class="mt-4">

                <div>
                    <label><strong>{{$t('business.profileFirst')}}</strong></label>
                </div>

                <div class="mt-6">
                    <button 
                    class="myGoToProfileButton"
                    @click="$router.push({ name: 'profile'});
                    "> {{$t('profile.goToProfile')}}</button>
                </div>
            </div>
        </div>

        <div v-else class="w-full flex justify-center mt-10">
            
            <ring-loader ></ring-loader> 
        </div>
    </div>
  

</template>

<script>

import Vue from 'vue';

import myTabs from '../components-v2/controls/MySessionsTabs'

import myDateBar from '../components-v2/Bars/MyDatesBar'

import { RingLoader } from 'vue-spinners-css';

import myQueries from '../hasura/myQueries';

import myInserts from '../hasura/myInserts';

import mySubscriptions from '../hasura/mySubscriptions';

import customerQueries from '../hasura/CustomerQueries';

import customerSubscriptions from '../hasura/CustomerSubscriptions';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import SessionCard from '../components-v2/cards/SessionCard.vue';

import sessionsPanel from '../components-v2/panels/SessionsPanel.vue';

import moment from 'moment';

// import SearchComponent from '../components/SearchComponent';

import SessionsMapModal from '../components-v2/maps/SessionsMapsModal.vue';

import componentsHelpers from '../classes/componentHelpers';

import sessionPage from '../components-v2/MyPages/SessionPage.vue';

// import MyTabs from '../components-v2/controls/MyTabs.vue';

import componentsMethods from '../classes/componentsMethods';

export default {

    name: "Sessions",  // using EXACTLY this name is essential

     created(){

        this.todayDate = this.dayDate;        
    },


    async mounted(){

        let result = await this.$auth.isAuthenticated();
            

        if(result == false){

            this.$router.push({ path: 'publicSessions' })
        }

        // console.log(`this.$userId`)

        // console.log(this.$userId)

        // console.log(`sessions mounted`)

        this.setDates();

    //    console.log(` this.panelObject.dayDate: ${ this.panelObject.dayDate}`);
        // this.$refs.sessionsPanel.setSlots();

        // console.log(`this.Data:${this.data}`)
        // this.minimizeAll = true;
        
        // localStorage.setItem('clientLayout2', 'sessions');

        if(!this.isFromBusinessBrowse && !this.isFromInstructorBrowse){

             this.$layoutType = 1;
        }

        this.slotSubscribeError = '';

        this.bookingsSubscribeError = '';

        this.slotError = '';

        const myFilter = item => Number(item.id) == Number(parameters.selected);        
    },

    components:{

        myDateBar,
        myTabs,
        SessionCard,
        SessionsMapModal,
        sessionPage,
        sessionsPanel
    },

    props:{

        isFromPage: false,

        myBusinessId: 0,
        myInstructorId: 0,

        isFromBusinessBrowse: false,
        isFromInstructorBrowse: false,        
    },


    methods:{ 

        refreshMap(){

            this.refreshedMap++;
        },

        tabIsSelected(tab){


            if(tab == 2){

            // console.log(`tabIsSelected: ${2}`);

                this.showMap = true;;
            }else{

            // console.log(`tabIsSelected: ${1}`);

                this.showMap = false;
            }
        },

        setDates(){

            // this.myDates = new Array();

            // this.myDates.push({
            //     date: this.fixedDayDate,
            //     day: this.weekDays[moment(this.fixedDayDate).isoWeekday() - 1]});
            
            // for(let j = 1; j < 15; j++){

            //     const i = j;

            //     const newDate = moment(this.fixedDayDate).add(i, 'day').format(moment.HTML5_FMT.DATE);

            //     if(i > 7){

            //         i = i - 7;
            //     }

            //     this.myDates.push({
            //     date: newDate,
            //     day: this.weekDays[moment(newDate).isoWeekday() - 1]
            //     });
            // }

            this.myDates = componentsMethods.getDates();

        },

        setDateFromBar(date){

            // this.panelObject.dayDate = date;

            const tempDate = moment(date).format(moment.HTML5_FMT.DATE);
            this.panelObject.dayDate = tempDate;
            // console.log(`date: ${this.panelObject.dayDate}`);

            this.$refs.sessionsPanel.setNewDate(tempDate)
            this.$refs.sessionsPanel.setSlots();
        },

        setDateFromPanel(date, isNext){

            // console.log(`date: ${date}`)

            // this.panelObject.dayDate = date;
            this.panelObject.dayDate = moment(date).format(moment.HTML5_FMT.DATE);
            // console.log(`date: ${this.panelObject.dayDate}`);
            this.$refs.sessionsBar.changeDate(isNext);
        },

        showDescription(mySlot){

            this.showClassPage(mySlot.class);
            // console.log(`showDescription Clicked with:${JSON.stringify(mySlot)}`);
        },

        isIos(){

            return componentsHelpers.isIos();
        },

        sendAddAnEvent(newEvent){
  

            if(typeof window.webkit != 'undefined'){
                
                window.webkit.messageHandlers.addAnEvent.postMessage(JSON.stringify(newEvent));
            }else{

            }                  
        },

        showClassPage(myClass){

            this.myClass = myClass;

            this.displayClassPage = true;
        },

        async closeClassPage(){

            if(this.aSessionIsBooked){
                
                // console.log(`after close now this.SessionIsBooked = false`)
                this.aSessionIsBooked = false;

                this.loading = true;

                await this.$apollo.queries.slot.refetch();

                await this.$apollo.queries.bookings.refetch();

                this.$refs.sessionsPanel.setSlots();

                this.loading = false;
            }

            this.myClass = null;

            this.displayClassPage = false;
        },



        openMapModal(){

            this.showMap = true;
        },

         openOneSlotMapModal(slot){

            this.showOnlyTheOneSLot = true;
            this.selectedOneSlot = slot;
            this.showMap = true;
        },
        
        async sleep(ms){
        
        this.count = this.count + 1;
        return await new Promise(resolve => setTimeout(resolve, ms));
        },

        displayModal(modalImages){

            if(modalImages.length > 0){  

                this.modalImages = modalImages;

                this.changeShowModal(true);
            }
        },

        changeShowModal(val){

            // console.log(`showModal: ${val}`);
            if(val == false){

                this.modalImages = [];
            }

            this.showModal = val;
        },

        changeShowMapModal(val){

            this.showMap = val;
            this.showOnlyTheOneSLot = val;
            this.selectedOneSlot = null;
        },

      
        myReload(){

            // let url = new URL(window.location.href);
            // url.searchParams.set('selected',this.businessOptionsProxy[0].id+'');
            // window.location.href = url.href;
            location.reload();
        },

        async book(slotToBook, index, bookingSuccessful, isGymSubscribed, isStudoSubscribed, paymentByPoints){
            
            // if(slotToBook.pay_cash && slotToBook.pay_points){

            //     alert(`what method to book`);
            //     return
            // }
            
            // bookingSuccessful(true);
            // console.log(`booking slot: ${JSON.stringify(slotToBook)}`);
            // return;
            // const componentsHelpers = componentsHelpers;
            
            const apollo = this.$apollo;

            const toasted = this.$toasted;

            let userId = this.userId;
            
            if(this.checkRequest(paymentByPoints, slotToBook))
            {
                try{
                    this.disableButton = true;

                    let points = slotToBook.points_cost;

                    let cash = slotToBook.cash_cost;
                    
                    // if(paymentByPoints){

                    //     cash = 0;
                    // }else{

                    //     points= 0; 
                    // }
                    
                    let result = await axios({method: 'post',url: '/pnadiapi/sessions/bookSession',
                        data: {
                        
                        key: this.storedKey,
                        userId: this.userId,
                        slotId: slotToBook.id,
                        points: points,
                        cash: cash,
                        dayDate: this.panelObject.dayDate,
                        paymentByPoints: paymentByPoints
                        }
                    });

                // console.log(`result is ${JSON.stringify(result)}`);

                    if(result.data == 'Booking was successful'){
                        
                        // console.log(`typeof: ${typeof this.$apollo.queries.bookings}`);

                        if(this.isIos()){

                            let event = {

                                id: slotToBook.id,
                                title: `${slotToBook.class.name}`,
                                startDate: `${this.dayDate} ${slotToBook.start_time}`,
                                endDate: `${this.dayDate} ${slotToBook.end_time}`,
                                location: '',
                                URL: ''
                            }

                            // console.log(`event: ${JSON.stringify(event)}`);


                            this.sendAddAnEvent(event)
                        }

                        if(typeof this.$apollo.queries.bookings != 'undefined'){

                            // console.log(`in refetch`);
                            
                            // const newBookings = await this.$apollo.queries.bookings.refetch();

                            // localStorage.setItem(`refetchBookings`, 'true');
                        }

                        if(!isGymSubscribed || isStudoSubscribed){
                            
                            this.user[0].coins = this.user[0].coins - slotToBook.points_cost;
                        }

                        bookingSuccessful(true);

                        this.$refs.sessionsPanel.setSlots();

                        this.disableButton = false;
                    }
                    else{

                        bookingSuccessful(false);

                        this.disableButton = false;

                        componentsHelpers.toastIt(this.$toasted, this.$t('payment.somethingWentWrong'), 3, 'outline', true)
                    }

                }
                catch(error){

                    // console.log(`in error: ${JSON.stringify(error)}`);
                    bookingSuccessful(false);

                    this.disableButton = false;

                    componentsHelpers.sendError(this.$apollo, this.userId,'Sessions', 'main', 'book', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true)
                }
            }
            else{

                bookingSuccessful(false);

                this.disableButton = false;
            }
        },

        checkRequest(slot, paymentByPoints){

            // console.log(`users are ${JSON.stringify(this.user)}`);
            if(paymentByPoints && this.user[0].coins < slot.points_cost){
                
                componentsHelpers.toastIt(this.$toasted, this.$t('sessions.youDontHaveEnoughPoints'), 3, 'outline', true);
                // alert(` You don't have enough points`);
                return false;
            }
            else if(slot.registered >= slot.capacity){


                componentsHelpers.toastIt(this.$toasted, this.$t('sessions.classIsFull'), 3, 'outline', true);
                // alert(`Session if full`);
                
                return false;
            }
            else {
                

                return true;
            }
        },
   
        setHighlightedLocation(index){

            this.highlightedLcoation = this.panelObject.categorizedSlots[index].class.location;
        },

        setASessionIsBooked(){

            console.log(`sessionIsBooked = true`);
            this.aSessionIsBooked = true;
        }
    },

    apollo: {
     
        withUser:{

            query: myQueries.token_and_user_query,

            update(data){

                try{

                    this.tokenId = data.token[0].id;
                            // console.log(`before in`)
                            // console.log(`${JSON.stringify(data.token[0].user)}`);

                    if(typeof data.token[0].user != 'undefined' && data.token[0].user!= null){

                        // console.log(`length of user ${data.token[0].user.length}`);

                        // if(data.token[0].user.length > 0 ){

                            this.user.push(data.token[0].user);

                            // console.log(`user : ${JSON.stringify(this.user)}`);
                            this.userId = this.user[0].id;
                            
                            // }
                        }
                        else{

                            // this.toastIt(this.$t('sessions.toBookCompleteProfile'), 2, 2);
                            // this.toastIt(this.$t('sessions.completeYourProfile'), 2, 2);
                            componentsHelpers.toastIt(this.$t('sessions.completeYourProfile'),  2, 'outline', true);

                            this.disablePage = true;
                        }
                    }catch(error){

                    componentsHelpers.sendError(this.$apollo, this.userId,'Sessions', 'apollo', 'withUser query - 1', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                }
            },

            error(error){
                
                componentsHelpers.sendError(this.$apollo, 0,'Sessions', 'apollo', 'withUser query - 2', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            },

            skip(){

                return JSON.stringify(this.$userId) == '{}';
            }
        },

        category: {

            query: myQueries.category_query,

            update(data){

                this.slotsCategoriesOptions = data.category;

            return data.category;
            },

            error(error){
                
                if(this.categoryError == ''){
                    
                    componentsHelpers.sendError(this.$apollo, 0,'Sessions', 'apollo', 'category query', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                    this.categoryError = JSON.stringify(error);
                }
            },

            skip(){

                return JSON.stringify(this.$userId) == '{}';
            }

        },

        slot: {

            query: function(){

                if(this.isFromBusinessBrowse){

                    if(this.user.length > 0 && this.slotError == ''){
                        
                        return customerQueries.slot_business_gender_query(this.user[0].gender)
                    }
                    else{

                        return customerQueries.slot_business_mixed_only_query;
                    }                    
                
                }else if(this.isFromInstructorBrowse){

                     if(this.user.length > 0 && this.slotError == ''){

                        // console.log(`in apollo slot instructor no error`);
                        
                        return customerQueries.slot_instructor_gender_query(this.user[0].gender)
                    }
                    else{

                        // console.log(`in apollo slot instructor with error`);

                        return customerQueries.slot_instructor_mixed_only_query;
                    }             
                
                }else{

                    if(this.user.length > 0 && this.slotError == ''){
                        
                    // console.log(`in apollo slot no error and user gender: ${this.user[0].gender}`);

                        return myQueries.slot_gender_query(this.user[0].gender)
                    }
                    else{

                        // console.log(`in apollo slot with error`);

                        return myQueries.slot_mixed_only_query;
                    } 
                }
            },

            variables: function(){
                
                // console.log`fixedDayDate: ${this.fixedDayDate}`;
                if(this.isFromBusinessBrowse){

                    return{

                        businessId: this.myBusinessId,

                        todayDate: this.fixedDayDate
                    }
                }else if(this.isFromInstructorBrowse){

                      return{

                        instructorId: this.myInstructorId,

                        todayDate: this.fixedDayDate
                    }                   
                
                }else{

                    return{
                        
                        todayDate: this.fixedDayDate
                    }
                }

            },

            update(data){

                // console.log(`update slots`)

            // console.log(`apollo slots: ${JSON.stringify(data.slot)}`)

                this.slot = data.slot;

            // this.setSlots();

            // this.panelObject.categorizedSlots =  this.slot;

                return data.slot;
            },


            error(error){
                
                // console.log(`in query`);

                if(this.slotError ==  ''){

                    componentsHelpers.sendError(this.$apollo, 0,'Sessions', 'apollo', 'slot query', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                    this.slotError = error;
                }
            },

            skip(){

                return JSON.stringify(this.$userId) == '{}';
            }
        },

         bookings:{

            query: myQueries.bookings_query,   


            variables: function(){

                return {

                }
            },

            update(data){

                if(this.userId != 0){

                    const userId = this.userId;

                    // console.log(`all data: ${JSON.stringify(data)}`);

                    // console.log(`all bookings: ${JSON.stringify(data.bookings)}`);

                    this.bookings = data.bookings.filter(item => item.user_id == userId);

                    // console.log(`filtered bookings: ${JSON.stringify(this.bookings)}`);
                    
                    return  this.bookings;
                }
            },

            error(error){

                if(this.bookingsError == ''){

                    this.bookingsError  =  error;

                    componentsHelpers.sendError(this.$apollo, this.userId,'Sessions', 'apollo', 'bookings', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                }
            },

            skip(){

                return JSON.stringify(this.$userId) == '{}';
            }
        },

        $subscribe:{

            slot: {

                query: function(){
                    
                    if(this.isFromBusinessBrowse){

                        if(this.user.length > 0 && this.slotSubscribeError == ''){
                      
                            return customerSubscriptions.slot_business_gender_subscription(this.user[0].gender)
                        }
                        else{
                            
                            return customerSubscriptions.slot_business_mixed_only_subscription;
                        }  
                    }else if(this.isFromInstructorBrowse){

                        if(this.user.length > 0 && this.slotSubscribeError == ''){
                        
                            return customerSubscriptions.slot_instructor_gender_subscription(this.user[0].gender)
                        }
                        else{

                            return customerSubscriptions.slot_instructor_mixed_only_subscription;
                        }  
                    }
                    else{

                        if(this.user.length > 0 && this.slotSubscribeError == ''){
                        
                            return mySubscriptions.slot_gender_subscription(this.user[0].gender)
                        }
                        else{
                            
                            return mySubscriptions.slot_mixed_only_subscription;
                        } 
                    }
                  
                },

                variables: function(){
                
                    if(this.isFromBusinessBrowse){

                         return{

                            businessId: this.myBusinessId,

                            todayDate: this.fixedDayDate
                        }

                    }else if(this.isFromInstructorBrowse){

                        return{

                            instructorId: this.myInstructorId,

                            todayDate: this.fixedDayDate
                        }
                    }
                    else{

                        return{

                            todayDate: this.fixedDayDate
                        }
                    }
            },

                result: function({data}){

                this.slot = data.slot;

                // this.panelObject.categorizedSlots =  this.slot;

                // this.setSlots();

                // this.goNextOrPrevious(true);

                return data.slot;
            },
            error(error){

                if(this.slotSubscribeError == ''){

                    componentsHelpers.sendError(this.$apollo, 0,'Sessions', 'apollo', 'slot subscribe', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                    this.slotSubscribeError = error;
                    }
                },

                skip(){

                    return JSON.stringify(this.$userId) == '{}';
                }
            },

            user: {

                query: mySubscriptions.user_info_subscription,

                update(data){

                this.user = data.user
            },

                error(error){
                
                if(this.subscribeUserError == ''){

                    componentsHelpers.sendError(this.$apollo, 0,'Sessions', 'apollo', 'user subscribe', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                    this.subscribeUserError = error;
                    }  
                },

                skip() {
                
                return JSON.stringify(this.$userId) == '{}';
              },
            },

            bookings_count: {

                query: mySubscriptions.bookings_count,
                

            update(data){

                    // console.log(`new bookings_counts ${JSON.stringify(data)}`);

                    // console.log(`new bookings_counts ${JSON.stringify(data.bookings_count)}`);
                    return data.bookings_count
                },

                error(error){
                    
                    if(this.bookingsCountsSubscribeError == ''){

                        componentsHelpers.sendError(this.$apollo, 0,'Sessions', 'apollo', 'user subscribe', error);

                        componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                        this.bookingsCountsSubscribeError = error;
                    }
                },
                
                skip() {
                
                return JSON.stringify(this.$userId) == '{}';
              },
            }
        }
    },

    data: function(){

        return{

            panelObject:{

                minimizeAll: false,
                onlyOnline: false,
                categorizedSlots: new Array(),
                dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            },

            myDates: [],

            weekDays:[
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday'
            ],

            testDates: 
                [
                    { 
                        date: '2020/12/03',
                        day: 'Saturday'
                    },
                    { 
                        date: '2020/12/04',
                        day: 'Sunday'
                    },
                    { 
                        date: '2020/12/05',
                        day: 'Monday'
                    },
                    { 
                        date: '2020/12/06',
                        day: 'Tuesday'
                    },
                    { 
                        date: '2020/12/07',
                        day: 'Wednesday'
                    },
                    { 
                        date: '2020/12/08',
                        day: 'Thursday'
                    },
                    { 
                        date: '2020/12/09',
                        day: 'Friday'
                    },
                    { 
                        date: '2020/12/10',
                        day: 'Saturday'
                    },
                ],

            showOnlyTheOneSLot: false,
            selectedOneSlot: null,
            // hide: true,
            disablePage: false,
            disableButton: false,
            onlyOnline: false,
            highlightedLcoation: null,
            showModal: false,
            showMap: false,
            tokenId: '',
            userId:0,
            email:'',
            user:[],
            category:[],
            categorizedSlots:[],
            timedCategorizedSlots:[],
            weekDayCategorizedSlots:[],
            slot:[],
            bookings: [],
            startTimeAfter: '',
            startTimeBefore: '',
            savedStartTimeAfter: '',
            savedStartTimeBefore: '',
            slotsCategoriesOptions: [],

            categoryError:'',
            slotError: '',
            bookingsError: '',
            dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            fixedDayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            todayDate: '',
            storedKey: localStorage.getItem('for_pnadi'),
            displayClassPage: false,
            myClass: null,

            refreshedMap: 0,

            aSessionIsBooked: false,

            loading: false,
        }
    },


}
</script>

<style>
/* height: 250px;
width: 250px; */
/* transform: translate(-50%, -50%); */

.bottom-up-enter-active{

    animation: slide-bottom-up 0.5s ease-in;
}

.bottom-up-leave-active{
    
    animation: slide-top-down 0.5s ease-in;
}

@keyframes slide-bottom-up{
        from  { transform: translateY(100%);}
        to { transform: translateY(0);} 
}
@keyframes slide-top-down{
    from  { transform: translateY(0%);}
    to { transform: translateY(100%);} 
}

.right-in-enter-active{

    animation: slide-right-in 0.5s ease-in;
}

.right-in-leave-active{
    
    animation: slide-right-out 0.5s ease-in;
}

@keyframes slide-right-in{
        from  { transform: translateX(100%);}
        to { transform: translateX(0);} 
}
@keyframes slide-right-out{
    from  { transform: translateX(0%);}
    to { transform: translateX(100%);} 
}


</style>